import { apiUrl }  from "../constants";
var axios = require('axios');
var request = axios.create({
    baseURL: apiUrl,
    headers: {'Authorization':localStorage.getItem('token'),'Content-Type':'application/json'}
})
export default class CourtsApi {
    static getAll() {
        return request.get(`/courts/${localStorage.getItem("rol")}`);
    }

    static get(id) {
        return request.get(`/courts/${localStorage.getItem("rol")}/${id}`);
    }

    static create(court) {
        return request.post('/courts',{court: court });
    }

    static edit(court, id){
        return request.put(`/courts/${id}`, {court: court});
    }

    static delete(id){
        return request.delete(`courts?id=${id}`);
    }
}


// WEBPACK FOOTER //
// ./src/api/Courts.js